import React from 'react'
import '../styles/index.scss'
import EmbroideryErrorInBatchPage from './EmbroideryErrorInBatchPage'

function EmbroideryErrorInBatchContainer() {
  return (
    <div className='EmbroideryErrorInBatchContainer'>
        <EmbroideryErrorInBatchPage/>
    </div>
  )
}

export default EmbroideryErrorInBatchContainer